import {NEW_ID} from '../../../common/constants/index.js'
import Icon from '../../../common/icons/Icon.js'
import className from '../../../common/className.js'
import {buildPath} from '../../../common/querystring.js'
import {API_KEYS, SETTINGS} from '../../../common/constants/SettingsPanels.js'
import Form from './Form.js'

export default function Item({apiKey, isExpanded}) {
  const editLink = '#' + buildPath([SETTINGS, API_KEYS, apiKey?.id || NEW_ID])

  return (
    <li
      id={editLink}
      className={className`settings-list-item clearfix ${{
        expanded: isExpanded,
      }}`}
    >
      {apiKey ? (
        <div className="wrap--row">
          <div className="medium-5 columns">
            <strong className="fs-01 margin-right-5 v-align-middle">
              {apiKey.name}
            </strong>
          </div>
          <div className="medium-2 columns align-right">
            <span className="fs-01  v-align-middle">
              <a
                className="inline-text-button settings-list-item-button edit-url"
                href={editLink}
              >
                <Icon name="sym-edit" className="fs-01 margin-right-2" />
                <span className="button-text">Edit</span>
              </a>
            </span>
          </div>
        </div>
      ) : (
        <div className="medium-12 columns button-wrap">
          <p>
            <a
              href={editLink}
              title="Add a return code"
              className="inline-text-button no-underline add-sales-channel-url"
            >
              <Icon name="sym-add" className="fs-01 margin-right-5" />
              <span>Add an API Key</span>
            </a>
          </p>
        </div>
      )}
      {isExpanded && <Form apiKey={apiKey} />}
    </li>
  )
}
